module.exports = __webpack_public_path__ + "static/media/copy-ic.03067c27.svg";